module.exports = __webpack_public_path__ + "img/doctor-notes-x.cebd2d5e.svg";